import { type ReactNode } from 'react';
import { Box, type BoxProps, type Theme, colorsPalette, styled } from '@lingoda/ui';

interface ClassStatusHeaderProps extends BoxProps {
    children?: ReactNode;
    color?: Color;
}

export const ClassStatusHeader = ({ color = 'gray', ...props }: ClassStatusHeaderProps) => {
    return <BoxStyled role="status" colorVariant={color} {...props} />;
};

type Color = 'purple' | 'primary' | 'orange' | 'green' | 'gray';

const BoxStyled = styled(Box, { shouldForwardProp: (name) => name !== 'colorVariant' })<{
    colorVariant: Color;
}>(({ theme, colorVariant }) => ({
    ...theme.typography.subtitle2,
    ...getColorStyles(theme)[colorVariant],
    width: '100%',
    padding: theme.spacing(1.5),
    textAlign: 'center',
}));

const getColorStyles = (theme: Theme) => ({
    primary: {
        background: theme.colors.background['accent-bold'],
        color: theme.colors.text.inverse,
    },
    gray: {
        backgroundColor: colorsPalette.blackSolid[3],
        color: theme.palette.text.secondary,
    },
    green: {
        backgroundColor: theme.colors.background['success-subtle'],
        color: theme.colors.text.success,
    },
    purple: {
        backgroundColor: colorsPalette.purpleSolid[4],
        color: colorsPalette.purpleCustom.dark,
    },
    orange: {
        backgroundColor: theme.colors.background['warning-subtle'],
        color: theme.colors.text.warning,
    },
});
